import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-l', 'IconLetterL', [
  ['path', { d: 'M7 4v16h10', key: 'svg-0' }],
]);
